export class KaskadenKontakt {
    public telefonAlarmierungKaskade: string;
    public telefonBereitschaft: string;
    public satellitenTelefonInmarsat: string;
    public satellitenTelefonIridium: string;
    public telefax: string;
    public emailAlarmierungKaskade: string;
    public emailKommunikation: string;
    public emailInformationKaskade: string;
    public emailKommunikation2: string;
    public emailKommunikation3: string;
    public emailKommunikation4: string;
}
